import types from './types'

export default {
  setModalData ({ commit }, payload = {}) {
    commit(types.SET_MODAL_DATA, payload)
  },
}
